// extracted by mini-css-extract-plugin
module.exports = {"previewTitle":"article-preview-module--previewTitle--3LTNW","tag":"article-preview-module--tag--3ZeSz"};